module.exports = __webpack_public_path__ + "static/media/landing image logo.419c3e01.png";